import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { licitacionesApi } from "@/lib/api/licitaciones";
import { LicitacionFilters, LicitacionListResponse } from "@/types/licitacion";

const licitacionesKeys = {
  all: ["licitaciones"] as const,
  list: (filters: LicitacionFilters) => [...licitacionesKeys.all, "list", filters] as const,
};

export function useLicitaciones(filters: LicitacionFilters = {}) {
  return useQuery<LicitacionListResponse>({
    queryKey: licitacionesKeys.list(filters),
    queryFn: () => licitacionesApi.getList(filters),
    staleTime: 30000,
    refetchOnWindowFocus: true,
  });
}

export function useDeleteLicitacion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (licitacionId: string) => licitacionesApi.remove(licitacionId),
    onSuccess: () => {
      // Invalida lista y detalles cacheados — el siguiente render
      // de /licitaciones o el dashboard refrescará.
      qc.invalidateQueries({ queryKey: licitacionesKeys.all });
      qc.invalidateQueries({ queryKey: ["licitacion"] });
    },
  });
}
